export default __webpack_public_path__ + "static/media/up_arrow_large.ce556f51.svg";